import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Appointment = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        // window.scrollTo(0, 0);

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])

    return (
        <>
            <section className="page-section" id="services">
                <div className="container">
                    {width?.winWidth > 770 ?
                        <div className="text-center">
                            <h2 className="section-heading text-uppercase">Want to make booking or </h2>
                            <h2 className="section-heading text-uppercase">have a question?</h2>
                            <h3 className="section-subheading text-muted">
                                Call us on +91 8141096997 or simply book an appointment
                            </h3>
                        </div>
                        :
                        <div className="text-center">
                            <h2 className="section-heading1 text-uppercase">Want to make booking or </h2>
                            <h2 className="section-heading1 text-uppercase">have a question?</h2>
                            <h3 className="section-subheading text-muted">
                                Call us on +91 8141096997 or simply book an appointment
                            </h3>
                        </div>}
                    <div className="text-center">
                        <Link
                            className="btn btn-primary btn-xl text-uppercase" to="/contact"
                        >
                            BOOK AN APPOINTMENT
                        </Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Appointment;